import { render, staticRenderFns } from "./IdleTimeSettings.vue?vue&type=template&id=17087b8f&"
import script from "./IdleTimeSettings.vue?vue&type=script&lang=js&"
export * from "./IdleTimeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports